import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=3b505836&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=3b505836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b505836",
  null
  
)

export default component.exports